import { render, staticRenderFns } from "./asset-allocation-statuses.vue?vue&type=template&id=0a4d05de"
import script from "./asset-allocation-statuses.vue?vue&type=script&lang=js"
export * from "./asset-allocation-statuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_cache-loader@4.1.0_webpack@4.47.0__css-load_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports